<!-- MODAL COLORS  -->
<div
    class="modal fade"
    id="app-modal-color-selector"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
    >
    <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        >
        <div
            class="modal-content rounded"
            [ngClass]="{'bg-dark white-text': isDarkmode}"
            >
            <app-header-title
                closeButton="closeButtonColorSelector"
                [title]="textTitle"
                modalId="app-modal-color-selector"
                >
            </app-header-title>
            <div class="modal-body">
                <div class="container">
                    <div
                        *ngFor="let colorGroup of colorPallete"
                        class="row d-flex justify-content-center"
                        >
                        <div
                            class="col-1 me-2 category-color-card"
                            *ngFor="let color of colorGroup.colors"
                            [ngStyle]="{'background-color': '#'+color}"
                            data-bs-dismiss="modal"
                            (click)="setColor(color)"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>